const columns = [
  {
    title: '服务器名称',
    key: 'age',
    width: 300
  },
  {
    title: '服务器IP',
    key: 'address',
  },
  {
    title: '服务器类型',
    key: 'id',
    width: 300,
  },
  {
    title: '操作',
    slot: 'iconfont',
    width: 200,
    iconClass: [
      {name: 'icon2', code: 'edit', status: 2, type: 'success', size: 'small'},
      {name: 'icon2', code: 'edit', status: 2, type: 'success', size: 'small'}
    ]
  },
]

export default columns